<script setup>
const props = defineProps({
    href: String,
    active: Boolean,
})
</script>

<template>
    <Link
        :href="href"
        :class="[
            active ? 'text-red-500' : 'text-white hover:text-red-600',
            'font-roboto-slab mx-4 transform text-lg leading-5 font-[500] tracking-wider uppercase transition-colors duration-300 md:my-0',
        ]"
    >
        <slot />
    </Link>
</template>
